import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/bank-account-integrations/{bankAccountIntegrationId}/documents']['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const addBankAccountDocuments = async ({ bankAccountIntegrationId, ...body }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/bank-account-integrations/${bankAccountIntegrationId}/documents`, {
    ...body,
  });
  return response.data;
};

export default addBankAccountDocuments;
